/* Titans Tactical — theme.js (vanilla, no dependencies) */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const R = window.routes || {};
  const T = window.themeStrings || {};
  const isRTL = document.documentElement.dir === 'rtl';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const debounce = (fn, ms = 250) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* ---------- Keep the visitor's language on internal links ----------
     Any link typed as a plain path (/collections/all) gets the current language prefix (/ar/...). */
  const langRoot = (R.root_url || '/').replace(/\/$/, '');
  const localizeLink = a => {
    if (!langRoot || !a || !a.getAttribute) return;
    const h = a.getAttribute('href');
    if (!h || h.charAt(0) !== '/' || h.startsWith('//')) return;
    if (h === langRoot || h.startsWith(langRoot + '/') || h.startsWith(langRoot + '?') || h.startsWith(langRoot + '#')) return;
    if (/^\/(cdn|checkouts|wallets|\.well-known)\b/.test(h)) return;
    a.setAttribute('href', langRoot + h);
  };
  if (langRoot) {
    const fixAll = () => $$('a[href^="/"]').forEach(localizeLink);
    fixAll();
    ['pointerdown', 'click', 'keydown', 'touchstart'].forEach(ev =>
      document.addEventListener(ev, e => { const a = e.target.closest && e.target.closest('a[href^="/"]'); if (a) localizeLink(a); }, true));
    if ('MutationObserver' in window) new MutationObserver(debounce(fixAll, 150)).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message) {
    let el = $('.t-toast');
    if (!el) { el = document.createElement('div'); el.className = 't-toast'; el.setAttribute('role', 'alert'); document.body.appendChild(el); }
    el.textContent = message; el.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { el.hidden = true; }, 4500);
  }

  /* ---------- Muted autoplay videos must carry these attributes ---------- */
  $$('video[autoplay]').forEach(v => { v.muted = true; v.setAttribute('playsinline', ''); });

  /* ---------- Header: sticky offset + shadow ---------- */
  const header = $('[data-header]');
  if (header) {
    const setH = () => document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(header);
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 4);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Drawers ---------- */
  let lastOpener = null;
  function openDrawer(id, opener) {
    const d = document.getElementById(id); if (!d) return;
    closeDrawers();
    closeSearch();
    lastOpener = opener || document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[data-drawer-open="' + id + '"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    const f = $('[data-drawer-focus]', d);
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 60);
  }
  function closeDrawers() {
    $$('.t-drawer.is-open').forEach(d => {
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      $$('[data-drawer-open="' + d.id + '"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    });
    document.body.classList.remove('is-locked');
    if (lastOpener && lastOpener.focus) lastOpener.focus({ preventScroll: true });
    lastOpener = null;
  }

  /* ---------- Search (predictive) ---------- */
  const searchPanel = $('[data-search]');
  const searchInput = $('[data-search-input]');
  const searchResults = $('[data-search-results]');
  let searchAbort;
  function openSearch(btn) {
    if (!searchPanel) return;
    closeDrawers();
    searchPanel.hidden = false;
    $$('[data-search-open]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => searchInput && searchInput.focus(), 30);
  }
  function closeSearch() {
    if (!searchPanel || searchPanel.hidden) return;
    searchPanel.hidden = true;
    $$('[data-search-open]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (searchResults) searchResults.innerHTML = '';
    if (searchInput) searchInput.value = '';
  }
  const runSearch = debounce(async () => {
    const q = searchInput.value.trim();
    if (q.length < 2) { searchResults.innerHTML = ''; return; }
    if (searchAbort) searchAbort.abort();
    searchAbort = new AbortController();
    try {
      const url = R.predictive_search_url + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
      const res = await fetch(url, { signal: searchAbort.signal });
      if (!res.ok) throw new Error(res.status);
      const node = parse(await res.text()).querySelector('#shopify-section-predictive-search');
      searchResults.innerHTML = node ? node.innerHTML : '';
    } catch (e) {
      if (e.name !== 'AbortError') searchResults.innerHTML = '<p class="t-psearch__empty">' + (T.noResults || '') + '</p>';
    }
  });
  if (searchInput) searchInput.addEventListener('input', runSearch);

  /* ---------- Cart ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = n < 1; });
  }
  async function refreshCart() {
    try {
      const res = await fetch(R.root_url + '?sections=cart-drawer');
      const data = await res.json();
      const next = parse(data['cart-drawer']).querySelector('[data-cart-drawer-content]');
      const cur = $('[data-cart-drawer-content]');
      if (next && cur) { cur.innerHTML = next.innerHTML; cur.dataset.itemCount = next.dataset.itemCount; setCount(+next.dataset.itemCount); }
    } catch (e) { /* silent */ }
  }
  async function changeLine(line, quantity) {
    const box = $('[data-cart-drawer-content]'); if (box) box.style.opacity = '.55';
    try {
      const res = await fetch(R.cart_change_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      });
      if (!res.ok) throw new Error((await res.json()).description || T.addError);
      await refreshCart();
    } catch (e) { toast(e.message || T.addError); }
    finally { if (box) box.style.opacity = ''; }
  }
  async function addToCart(form, btn) {
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    const errBox = $('[data-form-error]', form); if (errBox) errBox.hidden = true;
    try {
      const res = await fetch(R.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.addError);
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      await refreshCart(); openDrawer('CartDrawer', btn);
    } catch (e) {
      if (errBox) { errBox.textContent = e.message; errBox.hidden = false; } else toast(e.message);
    } finally { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
  }
  document.addEventListener('submit', e => {
    const form = e.target.closest('form[data-ajax-add]'); if (!form) return;
    const sub = e.submitter;
    if (sub && !sub.matches('[name="add"]')) return; // let dynamic checkout buttons work natively
    e.preventDefault();
    addToCart(form, sub || $('[name="add"]', form));
  });
  window.addEventListener('pageshow', e => { if (e.persisted) refreshCart(); });

  /* ---------- Click delegation ---------- */
  document.addEventListener('click', e => {
    const t = e.target;
    let el;
    if ((el = t.closest('[data-drawer-open]'))) { e.preventDefault(); openDrawer(el.dataset.drawerOpen, el); return; }
    if (t.closest('[data-drawer-close]')) { closeDrawers(); return; }
    if ((el = t.closest('[data-cart-toggle]')) && $('#CartDrawer') && !/\/cart\/?$/.test(location.pathname)) { e.preventDefault(); openDrawer('CartDrawer', el); return; }
    if (t.closest('[data-search-open]')) { e.preventDefault(); searchPanel && !searchPanel.hidden ? closeSearch() : openSearch(); return; }
    if (t.closest('[data-search-close]')) { closeSearch(); return; }
    if (searchPanel && !searchPanel.hidden && !t.closest('[data-search]')) closeSearch();

    if ((el = t.closest('[data-qty-step]'))) {
      const wrap = el.closest('.t-qty'); const input = $('input', wrap);
      const next = Math.max(input.min === '0' ? 0 : 1, (parseInt(input.value, 10) || 0) + Number(el.dataset.qtyStep));
      input.value = next;
      const drawer = el.closest('[data-cart-drawer-content]');
      if (drawer) changeLine(el.closest('[data-line]').dataset.line, next);
      else if (el.closest('[data-cart-form]')) el.closest('form').requestSubmit($('[data-cart-update]'));
      return;
    }
    if ((el = t.closest('[data-line-remove]')) && el.closest('[data-cart-drawer-content]')) {
      e.preventDefault(); changeLine(el.closest('[data-line]').dataset.line, 0); return;
    }
    if ((el = t.closest('[data-toggle-panel]'))) {
      e.preventDefault();
      ['LoginPanel', 'RecoverPanel'].forEach(id => { const p = document.getElementById(id); if (p) p.hidden = id !== el.dataset.togglePanel; });
      return;
    }
    if ((el = t.closest('[data-copy-link]'))) {
      const url = location.href.split('#')[0]; const label = $('[data-copy-label]', el);
      const done = () => { const old = label.textContent; label.textContent = T.linkCopied; setTimeout(() => { label.textContent = old; }, 2000); };
      if (navigator.share) navigator.share({ url, title: document.title }).catch(() => {});
      else if (navigator.clipboard) navigator.clipboard.writeText(url).then(done);
      return;
    }
    if ((el = t.closest('[data-zoom]'))) {
      const box = $('[data-lightbox]'); if (box && box.showModal) { $('[data-lightbox-img]', box).src = el.dataset.zoom; $('[data-lightbox-img]', box).alt = el.dataset.zoomAlt || ''; box.showModal(); }
      return;
    }
    if (t.closest('[data-lightbox-close]') || t.matches('[data-lightbox]')) { const b = $('[data-lightbox]'); b && b.close(); return; }
    if ((el = t.closest('[data-thumb]'))) {
      const item = $('[data-media-id="' + el.dataset.thumb + '"]'); item && item.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
      return;
    }
    if (t.closest('[data-sticky-add]')) {
      const f = $('form[data-ajax-add]', t.closest('[data-product]')); f && f.requestSubmit($('[name="add"]', f)); return;
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    if ($('.t-drawer.is-open')) closeDrawers();
    closeSearch();
  });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-auto-submit]')) { const f = e.target.closest('form'); if (f) f.requestSubmit ? f.requestSubmit() : f.submit(); }
    if (e.target.matches('[data-line-qty]') && e.target.closest('[data-cart-form]')) e.target.closest('form').requestSubmit($('[data-cart-update]'));
    if (e.target.matches('[data-line-qty]') && e.target.closest('[data-cart-drawer-content]')) changeLine(e.target.closest('[data-line]').dataset.line, e.target.value);
  });

  /* ---------- Facets ---------- */
  $$('[data-facet-form]').forEach(f => {
    f.addEventListener('submit', () => { $$('input[type="number"]', f).forEach(i => { if (!i.value) i.disabled = true; }); });
    f.addEventListener('change', debounce(e => { if (e.target.matches('input[type="checkbox"], input[type="number"]')) f.requestSubmit(); }, 200));
  });

  /* ---------- Sliders ---------- */
  $$('[data-slider]').forEach(s => {
    const track = $('[data-slider-track]', s); if (!track) return;
    const host = s.closest('section') || s;
    const prev = $('[data-slider-prev]', host), next = $('[data-slider-next]', host);
    const dir = isRTL ? -1 : 1;
    const step = () => Math.max(track.clientWidth * 0.85, 200);
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2; const pos = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = pos <= 2; if (next) next.disabled = pos >= max;
      [prev, next].forEach(b => b && (b.style.opacity = b.disabled ? '.35' : ''));
    };
    track.addEventListener('scroll', debounce(sync, 60), { passive: true }); sync();
    window.addEventListener('resize', debounce(sync, 150));
  });

  /* ---------- Rotators: hero + announcement ---------- */
  function rotator(root, slideSel, dotSel, speed, onChange) {
    const slides = $$(slideSel, root); if (slides.length < 2) return;
    const dots = dotSel ? $$(dotSel, root) : [];
    let i = 0, timer;
    const go = n => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); if (onChange) onChange(s, k === i); });
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const start = () => { if (!reduceMotion && root.dataset.autoplay === 'true') timer = setInterval(() => go(i + 1), speed); };
    const stop = () => clearInterval(timer);
    dots.forEach((d, k) => d.addEventListener('click', () => { stop(); go(k); }));
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', () => { stop(); start(); });
    go(0); start();
  }
  $$('[data-hero]').forEach(h => rotator(h, '[data-hero-slide]', '[data-hero-dot]', Number(h.dataset.speed) || 7000, (s, on) => {
    $$('video', s).forEach(v => { if (on) v.play().catch(() => {}); else v.pause(); });
  }));
  $$('[data-announce]').forEach(a => rotator(a, '.t-announce__msg', null, Number(a.dataset.speed) || 5000));

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(async el => {
    try {
      const res = await fetch(el.dataset.url); if (!res.ok) return;
      const rec = parse(await res.text()).querySelector('[data-recommendations]');
      if (rec && rec.innerHTML.trim()) el.innerHTML = rec.innerHTML;
      else { const sec = el.closest('section'); sec && sec.remove(); }
    } catch (e) { /* silent */ }
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(root => {
    const stage = $('[data-gallery-stage]', root);
    const thumbs = $$('[data-thumb]', root);
    if (stage && thumbs.length) {
      const items = $$('[data-media-id]', stage);
      const sync = () => {
        const idx = Math.round(Math.abs(stage.scrollLeft) / (stage.clientWidth || 1));
        const id = items[idx] && items[idx].dataset.mediaId;
        thumbs.forEach(t => t.classList.toggle('is-active', t.dataset.thumb === id));
      };
      stage.addEventListener('scroll', debounce(sync, 50), { passive: true });
    }

    // sticky add-to-cart bar
    const sticky = $('[data-sticky]', root), anchor = $('[data-buy-anchor]', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', String(!show));
        const b = $('[data-sticky-add]', sticky); if (b) b.tabIndex = show ? 0 : -1;
      }).observe(anchor);
    }

    // variants
    const picker = $('[data-variant-picker]', root); const dataEl = $('[data-variants]', root);
    if (!picker || !dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const sets = () => $$('fieldset', picker);
    const chosenNow = () => sets().map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
    // Does this option value still have stock? Only the options chosen BEFORE it are considered, so a colour
    // is marked sold out only when every size in that colour is gone (one size left = still available).
    const hasStock = (idx, value, chosen) => variants.some(v => v.available && v.options[idx] === value &&
      v.options.every((o, i) => i >= idx || o === chosen[i]));
    const updateAvailability = () => {
      const chosen = chosenNow();
      sets().forEach((fs, idx) => {
        const items = $$('[data-option-input]', fs).map((inp, domPos) => {
          if (inp.dataset.orig === undefined) inp.dataset.orig = domPos; // remember the original order
          const pos = Number(inp.dataset.orig);
          const inStock = hasStock(idx, inp.value, chosen);
          const label = inp.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !inStock);
          return { inp, label, pos, inStock };
        });
        // Sort: values with stock first, sold-out values last (original order kept inside each group)
        const box = $('.t-option__values', fs); if (!box) return;
        const sorted = items.slice().sort((x, y) => (y.inStock - x.inStock) || (x.pos - y.pos));
        if (sorted.every((it, k) => it === items[k])) return;
        const focused = document.activeElement;
        sorted.forEach(it => { box.appendChild(it.inp); if (it.label) box.appendChild(it.label); });
        if (focused && focused.matches && focused.matches('[data-option-input]')) focused.focus({ preventScroll: true });
      });
    };
    // If the chosen combination is sold out but the same colour (earlier options) has other sizes in stock,
    // switch the later options to the best in-stock combination. Returns true when something changed.
    const fixSelection = changedIdx => {
      const sel = chosenNow();
      const cur = variants.find(v => v.options.every((o, i) => o === sel[i]));
      if (cur && cur.available) return false;
      const cands = variants.filter(v => v.available && v.options.every((o, i) => i > changedIdx || o === sel[i]));
      if (!cands.length) return false;
      let best = cands[0], bestScore = -1;
      cands.forEach(v => {
        const score = v.options.reduce((n, o, i) => n + (i > changedIdx && o === sel[i] ? 1 : 0), 0);
        if (score > bestScore) { best = v; bestScore = score; }
      });
      let changed = false;
      sets().forEach((fs, i) => {
        if (i <= changedIdx) return;
        const inp = $$('[data-option-input]', fs).find(x => x.value === best.options[i]);
        if (inp && !inp.checked) { inp.checked = true; changed = true; }
      });
      return changed;
    };
    const apply = async () => {
      updateAvailability();
      sets().forEach(fs => { const c = $('input:checked', fs), l = $('[data-option-label]', fs); if (c && l) l.textContent = c.value; });
      const selected = chosenNow();
      const variant = variants.find(v => v.options.every((o, i) => o === selected[i]));
      const addBtns = $$('[data-add-btn], [data-sticky-add]', root);
      if (!variant) { addBtns.forEach(b => { b.disabled = true; b.textContent = T.unavailable; }); return; }
      const qtyEl = $('[data-qty-input]', root); const qty = qtyEl ? qtyEl.value : 1;
      if (root.dataset.updateUrl === 'true') history.replaceState(null, '', '?variant=' + variant.id);
      try {
        const res = await fetch(root.dataset.url + '?variant=' + variant.id + '&section_id=' + root.dataset.sectionId);
        const doc = parse(await res.text());
        $$('[data-swap]', root).forEach(el => { const src = doc.querySelector('[data-swap="' + el.dataset.swap + '"]'); if (src) el.innerHTML = src.innerHTML; });
        const q = $('[data-qty-input]', root); if (q) q.value = qty;
      } catch (err) { /* keep current UI */ }
      const mid = variant.featured_media && variant.featured_media.id;
      const item = mid && $('[data-media-id="' + mid + '"]', root);
      if (item) item.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
    };
    picker.addEventListener('change', e => {
      if (!e.target.matches('[data-option-input]')) return;
      fixSelection(sets().indexOf(e.target.closest('fieldset')));
      apply();
    });
    // Show the photo that belongs to the selected variant (instantly, no animation)
    const showVariantMedia = behavior => {
      const sel = chosenNow();
      const v = variants.find(x => x.options.every((o, i) => o === sel[i]));
      const mid = v && v.featured_media && v.featured_media.id;
      const item = mid && $('[data-media-id="' + mid + '"]', root);
      if (item) item.scrollIntoView({ behavior, block: 'nearest', inline: 'start' });
    };
    // On load: a sold-out default (e.g. Bronze / S) moves to the first size that is in stock (Bronze / XL)
    if (fixSelection(0)) apply(); else updateAvailability();
    showVariantMedia('auto');
  });
})();
